var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgW40DealsSkeuomorphic = function SvgW40DealsSkeuomorphic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 34"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w-40-deals-skeuomorphic_svg__a)",
    filter: "url(#w-40-deals-skeuomorphic_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w-40-deals-skeuomorphic_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FBFAFA",
    d: "M1.53 10.152a8 8 0 0 1 7.48-8.489L28.97.401a8 8 0 0 1 8.49 7.479l1.01 15.968a8 8 0 0 1-7.48 8.489l-19.96 1.262a8 8 0 0 1-8.489-7.478z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#w-40-deals-skeuomorphic_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#999",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.23,
    strokeWidth: 1.5,
    d: "M8.617 27.139q2.818-4.96 2.637-7.819c-.18-2.858-.804-2.818-1.428-2.779s-1.202 1.114-1.067 2.937c.145 1.95 1.328 4.58 1.921 5.618 1.056 1.846 1.71 2.282 2.244.814l1.066-2.937q.553 3.791 2.112 3.692c.331-.02 1.526-2.01 1.751-2.023q.485-.03 1.992 1.787"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#8E8E8E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8.504 25.343q2.817-4.961 2.637-7.819c-.181-2.858-.805-2.818-1.429-2.779-.623.04-1.202 1.114-1.066 2.937.144 1.95 1.328 4.58 1.92 5.617 1.057 1.846 1.71 2.283 2.244.815l1.067-2.937q.552 3.79 2.112 3.692c.33-.021 1.526-2.01 1.75-2.024q.484-.03 1.992 1.787"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#44BA82",
    d: "M.028 2.231 36.954-.105l.379 5.988L.407 8.22z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#0A0A0A",
    strokeOpacity: 0.1,
    d: "M9.041 2.162 29.001.9a7.5 7.5 0 0 1 7.96 7.011l1.01 15.968a7.5 7.5 0 0 1-7.012 7.959L10.999 33.1A7.5 7.5 0 0 1 3.04 26.09L2.03 10.12a7.5 7.5 0 0 1 7.011-7.959Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "w-40-deals-skeuomorphic_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 33.333,
    fill: "#fff",
    rx: 8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w-40-deals-skeuomorphic_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.53 10.152a8 8 0 0 1 7.48-8.489L28.97.401a8 8 0 0 1 8.49 7.479l1.01 15.968a8 8 0 0 1-7.48 8.489l-19.96 1.262a8 8 0 0 1-8.489-7.478z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "w-40-deals-skeuomorphic_svg__b",
    width: 39.949,
    height: 36.209,
    x: 0.026,
    y: -0.104,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2597_19823"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2597_19823",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "w-40-deals-skeuomorphic_svg__d",
    width: 16.727,
    height: 16.107,
    x: 5.867,
    y: 13.782,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2597_19823",
    stdDeviation: 1
  })))));
};
export default SvgW40DealsSkeuomorphic;